import { DATE_WITH_TIME_FORMAT, formatDateToLocalSimple } from '@shared/utils';
import { EmailProviderTypeEnum } from '@shared/enums';

const failureEmailStatuses = ['dropped', 'failed', 'bounce', 'bounced', 'deferred', 'suppressed'];

const normalizeEmailProviderType = (providerType: EmailProviderTypeEnum | string): EmailProviderTypeEnum => {
  const normalizedProviderType = providerType?.toString().trim().toLowerCase();

  if (normalizedProviderType === 'sendgrid' || normalizedProviderType === '1') {
    return EmailProviderTypeEnum.SendGrid;
  }

  if (normalizedProviderType === 'office365' || normalizedProviderType === '2') {
    return EmailProviderTypeEnum.Office365;
  }

  return null;
};

export interface EmailEventModel {
  eventType: string;
  providerResponse: string;
}

export class EmailDataModel {
  id: number;
  name: string;
  toEmailAddress: string;
  emailStatus: string;
  providerType: EmailProviderTypeEnum;
  sentDate: string;
  deliveredDate: string;
  readDate: string;
  failedDate: string;
  failedReason: string;
  isFailureStatus: boolean;
  canViewEmailEvents: boolean;
  emailEvents: EmailEventModel[];

  constructor(dto: any) {
    this.id = dto.id;
    this.name = dto.memberName || '';
    this.toEmailAddress = dto.toEmailAddress || '';
    this.emailStatus = dto.emailStatus || '';
    this.providerType = normalizeEmailProviderType(dto.providerType);
    this.isFailureStatus = failureEmailStatuses.includes(this.emailStatus.trim().toLowerCase());
    this.canViewEmailEvents = this.providerType === EmailProviderTypeEnum.SendGrid && this.isFailureStatus;
    this.sentDate = dto.emailSentDate ? formatDateToLocalSimple(dto.emailSentDate, DATE_WITH_TIME_FORMAT) : '-';
    this.deliveredDate = dto.dateDelivered
      ? formatDateToLocalSimple(dto.dateDelivered, DATE_WITH_TIME_FORMAT)
      : '-';
    this.readDate = dto.dateOpened ? formatDateToLocalSimple(dto.dateOpened, DATE_WITH_TIME_FORMAT) : '-';
    this.failedDate =
      this.isFailureStatus
        ? formatDateToLocalSimple(dto.dateCreated, DATE_WITH_TIME_FORMAT)
        : '-';
    this.failedReason = dto.failedReason || null;
    this.emailEvents = Array.isArray(dto.emailEvents)
      ? dto.emailEvents.map(event => ({
        eventType: event?.eventType || '',
        providerResponse: event?.providerResponse || '-'
      }))
      : [];
  }
}
